export interface LineItemsPostBody {
  AccountType: string;
  Account: string;
  TaxCode: string;
  TaxJurisdictionCode: string;
  TradingPartner: string;
  CostCenter: string;
  InternalOrder: string;
  ProfitCenter: string;
  MaterialGroup: string;
  LineDesc: string;
  LineAmount: string;
}

export interface LineItemsResponse {
  // lineRefguid: string | null; NOT USED
  account: string | null;
  accountType: string | null;
  costCenter: string | null;
  internalOrder: string | null;
  taxJurisdictionCode: string | null;
  taxCode: string | null;
  materialGroup: string | null;
  tradingPartner: string | null;
  profitCenter: string | null;
  lineAmount: string | null;
  lineDesc: string | null;
}

export type LineItemProperty =
  | "accountType"
  | "account"
  | "costCenter"
  | "internalOrder"
  | "profitCenter"
  | "tradingPartner"
  | "materialGroup"
  | "taxCode"
  | "taxJurisdictionCode"
  | "lineDesc"
  | "lineAmount";

export function getMapColIndexToLineItemNamesInOrderFromApi(): LineItemProperty[] {
  return [
    "accountType",
    "account",
    "costCenter",
    "internalOrder",
    "profitCenter",
    "tradingPartner",
    "materialGroup",
    "taxCode",
    "taxJurisdictionCode",
    "lineDesc",
    "lineAmount"
  ];
}

export function getLineItemsHeaders(): string[] {
  return [
    "Account Type",
    "Account Number",
    "Cost Center",
    "Internal Order",
    "Profit Center",
    "Trading Partner",
    "Material Group",
    "Tax Code",
    "Tax Jurisdiction Code",
    "Line Desc.",
    "Document Amount"
  ];
}
